module.exports = __webpack_public_path__ + "static/vehiclejigsaw-085f68d84cef07536ef2b65aa055aa96.png";